import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import SearchStatement from '../../components/Search/SearchStatement';
import TableStatmentOnline from '../../components/TableStatmentOnline/TableStatmentOnline';
import Loading from '../../components/Loading';
import { useGetStatementOnlineQuery,useLazyGetStatementOnlineQuery } from '../../services/statementOnline';
import { checkAccessRights } from '../../utils/functions/accessRight';
import { ROLES } from '../../utils/constants';
import StatementOnlineEditDialog from '../../components/Dialog/StatementOnlineEditDialog';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';

import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const formatStatementDateTime = (value) =>
  value ? dayjs.utc(value).add(7, 'hour').format('YYYY-MM-DD HH:mm:ss.SSS') : '';

const EXPORT_PAGE_SIZE = 5000;
const EXCEL_ROWS_PER_SHEET = 50000;

const downloadWorkbook = (workbook, fileName) => {
  const workbookData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([workbookData], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

const enumerateDates = (startDate, endDate) => {
  const dates = [];
  let current = dayjs(startDate).startOf('day');
  const last = dayjs(endDate).startOf('day');

  while (current.isValid() && last.isValid() && current.isBefore(last.add(1, 'day'))) {
    dates.push(current.format('YYYY-MM-DD'));
    current = current.add(1, 'day');
  }

  return dates;
};

function StatementOnline() {
  const { t } = useTranslation();
  const { value: merchant, allMerchant } = useSelector(
    (state) => state.merchant,
  );
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
const [fetchAllStatement] = useLazyGetStatementOnlineQuery();
  const [page, setPage] = useState(0);
  const [sortBy, setSortBy] = useState('transaction_date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [total, setTotal] = useState(0);

  const [statementValue, setStatementValue] = useState([]);

  const [open, setOpen] = useState(false);
  const [value, setValue] = useState({});
  const [statusItems, setStatusItems] = useState([
    { label: 'Match', value: 'match' },
    { label: 'Unmatch', value: 'unmatch' },
    { label: 'Partial', value: 'partial' },
  ]);
  const [detailStatusItems, setDetailStatusItems] = useState([
    { label: 'Manual', value: 'Manaul', disable: false },
    { label: 'Booking', disable: false },
    { label: 'Suspense', disable: false },
    { label: 'Suspense - AR', disable: false },
    { label: 'Partial Suspense', disable: false },
    { label: 'เงินรับ JV', disable: false },
    { label: 'เงินยืม JV', disable: false },
    { label: 'โยกเงิน', disable: false },
    { label: 'ดึงเงินระหว่างบัญชี', disable: false },
    { label: 'เช็คเด้ง-โอนเด้ง', disable: false },
    { label: 'เงินรับ OPS', disable: false },
    { label: 'รายได้อื่น - HR', disable: false },
    { label: 'รายได้อื่น - TAX', disable: false },
    { label: 'รายได้อื่น - BANK', disable: false },
    { label: 'รายได้อื่น - REIT', disable: false },
    { label: 'รายได้อื่น - เงินกู้', disable: false },
    { label: 'รายได้อื่น - Factoring', disable: false },
    { label: 'รายได้อื่น - เงินลงทุน', disable: false },
    { label: 'รายได้อื่น - ค่าปรับพนักงาน', disable: false },
    { label: 'รายได้อื่น - Other', disable: false },
    { label: 'เงินจ่าย OPS', disable: false },
    { label: 'รายจ่ายอื่น - BANK', disable: false },
    { label: 'รายจ่ายอื่น - เงินกู้', disable: false },
    { label: 'รายจ่ายอื่น - Factoring', disable: false },
    { label: 'รายจ่ายอื่น - เงินลงทุนอื่น', disable: false },
    { label: 'รายจ่ายอื่น - ค่าธรรมเนียม', disable: false },
  ]);
  const [formDefaultData, setFormDefaultData] = useState({
    bank: '',
    accountNo: '',
    status: '',
    detailStatus: '',
    startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    startEffectiveDate: '',
    endEffectiveDate: '',
    creditAmount: '',
    debitAmount: '',
    search: '',
  });

  const isAdminRole = checkAccessRights(ROLES.ADMIN_ROLE);
  const sorgcode = isAdminRole ? merchant || '' : allMerchant || '-';
  const shouldSkip = isAdminRole && !merchant;

  const {
    data: getList,
    isFetching,
    isLoading,
    refetch,
  } = useGetStatementOnlineQuery(
    {
      bank: formDefaultData.bank || '',
      accountNo: formDefaultData.accountNo || '',
      status: formDefaultData.status || '',
      detailStatus: formDefaultData.detailStatus || '',
      startDate: formDefaultData.startDate
        ? dayjs(formDefaultData?.startDate).format('YYYY-MM-DD')
        : dayjs().startOf('month').format('YYYY-MM-DD'),
      endDate: formDefaultData.endDate
        ? dayjs(formDefaultData?.endDate).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD'),
      startEffectiveDate: formDefaultData.startEffectiveDate
        ? dayjs(formDefaultData?.startEffectiveDate).format('YYYY-MM-DD')
        : '',
      endEffectiveDate: formDefaultData.startEffectiveDate
        ? dayjs(formDefaultData?.endEffectiveDate).format('YYYY-MM-DD')
        : '',
      creditAmount: formDefaultData.creditAmount || NaN,
      debitAmount: formDefaultData.debitAmount || NaN,
      search: formDefaultData.search || '',
      sorgcode,
      size: rowsPerPage,
      page: page + 1,
      sortBy,
      sortOrder,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: shouldSkip,
    },
  );

  const buildStatementQuery = ({ page: exportPage, size, startDate, endDate }) => ({
    bank: formDefaultData.bank || '',
    accountNo: formDefaultData.accountNo || '',
    status: formDefaultData.status || '',
    detailStatus: formDefaultData.detailStatus || '',
    startDate: startDate || (formDefaultData.startDate
      ? dayjs(formDefaultData?.startDate).format('YYYY-MM-DD')
      : dayjs().startOf('month').format('YYYY-MM-DD')),
    endDate: endDate || (formDefaultData.endDate
      ? dayjs(formDefaultData?.endDate).format('YYYY-MM-DD')
      : dayjs().format('YYYY-MM-DD')),
    startEffectiveDate: formDefaultData.startEffectiveDate
      ? dayjs(formDefaultData?.startEffectiveDate).format('YYYY-MM-DD')
      : '',
    endEffectiveDate: formDefaultData.endEffectiveDate
      ? dayjs(formDefaultData?.endEffectiveDate).format('YYYY-MM-DD')
      : '',
    creditAmount: formDefaultData.creditAmount || NaN,
    debitAmount: formDefaultData.debitAmount || NaN,
    search: formDefaultData.search || '',
    sorgcode,
    size,
    page: exportPage,
  });

 const handleExportExcel = async () => {
    try {
      setIsExporting(true);
      setExportProgress('');
      const exportStartDate = formDefaultData.startDate
        ? dayjs(formDefaultData?.startDate).format('YYYY-MM-DD')
        : dayjs().startOf('month').format('YYYY-MM-DD');
      const exportEndDate = formDefaultData.endDate
        ? dayjs(formDefaultData?.endDate).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD');
      const exportDates = enumerateDates(exportStartDate, exportEndDate);

      const toExportRow = (item) => ({
        [t('app.statementRef')]: item.statement_ref || '',
        [t('app.bookbankNo')]: item.bookbank || '',
        [t('app.dateTime')]: formatStatementDateTime(item.transaction_date),
        [t('app.effectiveStartDate')]: formatStatementDateTime(item.effective_date),
        [t('app.actualReceived')]: item.amount || 0,
        [t('app.actualPaid')]: item.debit_amount || 0,
        [t('app.amountUsed')]: item.new_spend_amount || 0,
        [t('app.balance')]: item.new_balance || 0,
        [t('app.broughtForward')]: item.balance || 0,
        [t('app.status')]: item.status || '',
        [t('app.detailStatus')]: item.detail_status || '',
        [t('app.remark')]: item.remark || '',
        [t('app.description')]: item.description || '',
        [t('app.channel')]: item.channel || '',
        [t('navbar.custNo')]: item.customer_code || '',
        [t('navbar.custName')]: item.customer_name || '',
        [t('app.invoiceNo')]: item.invoice_no || '',
        [t('app.bsNo')]: item.bs_no || '',
        [t('app.rc03')]: item.RC03 || '',
        [t('app.chqNo')]: item.check_no || '',
        [t('app.updateBy')]: item.edit_by || '',
      });

      const workbook = XLSX.utils.book_new();
      let sheetRows = [];
      let sheetIndex = 1;
      let fetchedRows = 0;
      const expectedTotal = total || 0;

      const appendSheet = () => {
        if (sheetRows.length === 0) {
          return;
        }

        const worksheet = XLSX.utils.json_to_sheet(sheetRows);
        XLSX.utils.book_append_sheet(workbook, worksheet, `Statement_${sheetIndex}`);
        sheetRows = [];
        sheetIndex += 1;
      };

      for (const exportDate of exportDates) {
        let currentPage = 1;
        let totalPages = 1;

        do {
          const response = await fetchAllStatement(
            buildStatementQuery({
              page: currentPage,
              size: EXPORT_PAGE_SIZE,
              startDate: exportDate,
              endDate: exportDate,
            }),
          ).unwrap();
          const rows = response?.data || [];
          const dayTotal = response?.pagination?.total || rows.length;

          totalPages = Math.max(1, Math.ceil(dayTotal / EXPORT_PAGE_SIZE));
          sheetRows.push(...rows.map(toExportRow));
          fetchedRows += rows.length;
          setExportProgress(
            expectedTotal
              ? `${Math.min(fetchedRows, expectedTotal)}/${expectedTotal}`
              : `${fetchedRows}`,
          );

          if (rows.length === 0) {
            break;
          }

          if (sheetRows.length >= EXCEL_ROWS_PER_SHEET) {
            appendSheet();
          }

          currentPage += 1;
        } while (currentPage <= totalPages);
      }

      appendSheet();

      if (fetchedRows === 0) {
        alert(t('app.noDataAvailable'));
        setIsExporting(false);
        return;
      }

      setExportProgress('creating file');
      const fileName = `Statement_All_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`;
      downloadWorkbook(workbook, fileName);

    } catch (error) {
      console.error('Export Excel Error:', error);
      alert('เกิดข้อผิดพลาดในการดึงข้อมูลสำหรับ Export');
    } finally {
      setIsExporting(false); 
      setExportProgress('');
    }
  };

  useEffect(() => {
    if (getList) {
      const { pagination, data: rows } = getList;
      setTotal(pagination.total);
      setStatementValue(rows);
    }
    return () => {};
  }, [getList]);

  useEffect(() => {
    setPage(0);
  }, [merchant]);

  const handleClose = (newValue) => {
    setOpen(false);
    if (newValue) {
      setValue(newValue);
    }
  };

  const searchData = async (nextFilterData) => {
    setPage(0);
    if (nextFilterData) {
      setFormDefaultData(nextFilterData);
      return;
    }
    refetch();
  };

  return (
    <div className="flex flex-col">
      <div className="my-2 ml-2">
        <div className="text-lg font-light flex flex-wrap items-center justify-between">
          <div className="lg:w-3/4 w-1/2 font-bold">{t('app.statement')}</div>
        </div>
      </div>
      <SearchStatement
        t={t}
        statusItems={statusItems}
        detailStatusItems={detailStatusItems}
        formDefaultData={formDefaultData}
        setFormDefaultData={setFormDefaultData}
        callApiGetStatementOnline={searchData}
        merchant={merchant}
        setPage={setPage}
        onExportExcel={handleExportExcel} // ✅ ส่งฟังก์ชันไปให้ปุ่ม
        isExporting={isExporting} // ✅ ส่งสถานะโหลดไปบอกปุ่ม
        exportProgress={exportProgress}
      />
      <TableStatmentOnline
        t={t}
        isLoading={isLoading}
        isFetching={isFetching}
        statementValue={statementValue}
        openDraopenwer={open}
        setOpen={setOpen}
        setValue={setValue}
        page={page}
        setPage={setPage}
        total={total}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        sortBy={sortBy}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
      />
      <StatementOnlineEditDialog
        t={t}
        open={open}
        onClose={handleClose}
        value={value}
        statusItems={statusItems}
        detailStatusItems={detailStatusItems}
        refetch={refetch}
      />
    </div>
  );
}

export default StatementOnline;
